import { loadScript } from './tools';

const selector = '[data-neocom-id]';
const script = 'https://production.neocomapp.com/neocom.js?id=7ae6c0b7-1e29-4731-810e-295c17bdf818';

const el = document.querySelector(selector);

if (el) {
    const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
            delete window.Neocom;

            loadScript(script);
            observer.unobserve(el);
        }
    });

    observer.observe(el);
}

if (typeof window.Neocom === 'undefined') {
    const openAdvisorInModal = (projectId) => {
        if (typeof window.Neocom === 'undefined') {
            return setTimeout(() => {
                openAdvisorInModal(projectId);
            }, 25);
        }

        window.Neocom.openAdvisorInModal(projectId);
    };

    window.Neocom = {
        openAdvisorInModal(projectId) {
            delete window.Neocom;

            loadScript(script, () => {
                openAdvisorInModal(projectId);
            });
        },
        _cbk_load() {
            delete window.Neocom;
            loadScript(script);
        },
    };
}
